export enum Client {
    graph = 'graph',
}
